import angular from 'angular';
import './style.scss';

angular.module('TALENYA-FE').controller('editCriteriaGroupPopupCtrl', function ($uibModalInstance, field, data, onSaveData ) {
    const self = this;
    let originalGroupItem;

    self.groupItems = {
        field: field,
        subCriteria: null,
        selected: [],
    };

    for (const criteriaGroupItem of data) {
        self.groupItems.selected = [...criteriaGroupItem.group];
        originalGroupItem = criteriaGroupItem;
        self.groupPriority = criteriaGroupItem.required;
        break;
    }
    self.ok = function () {
        onSaveData({originalGroupItem, modifiedGroup: self.groupItems });
        $uibModalInstance.close('Ok');
    };

    self.cancel = function () {
        $uibModalInstance.dismiss('Cancel');
    };

    self.breakAllItemsApart = function () {
        onSaveData({originalGroupItem, modifiedGroup: self.groupItems, unGroup: true });
        $uibModalInstance.close('Ok');
    };
});